import { render } from "./SnapToGrid.vue?vue&type=template&id=a9a24b7c"
import script from "./SnapToGrid.vue?vue&type=script&lang=js"
export * from "./SnapToGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__